module.exports = __webpack_public_path__ + "img/40_01_013_403.31b3dc3b.jpg";